export const OBSERVATION_CATEGORIES_DATA = [
  {
    label: 'Protocol / Procedure Error',
    subcategories: [
      { label: 'Wrong imaging sequences in protocol', value: 'wrong_imaging_sequences_in_protocol' },
      { label: 'Missing required sequence/phase', value: 'missing_required_sequence_phase' },
      { label: 'Study performed does not match order', value: 'study_performed_does_not_match_order' },
      { label: 'Radiologic contrast administration', value: 'radiologic_contrast_administration' },
      { label: 'Incomplete contrast series (e.g. missing pre/post)', value: 'incomplete_contrast_series' },
      { label: 'Missing scout/localizer', value: 'missing_scout_localizer' },
      { label: 'Missing marker for site of localized mass/symptoms', value: 'missing_marker_for_site' },
      { label: 'Imaging parameters', value: 'imaging_parameters' },
      { label: 'Incorrect coil or transducer used', value: 'incorrect_coil_or_transducer_used' },
      { label: 'Required post-processing (MIP, recon) missing', value: 'required_post_processing_missing' },
      { label: 'Artifact-reduction protocol (e.g., IMAR) not used when indicated', value: 'artifact_reduction_protocol_not_used' },
      { label: 'Medication prep or timing error (e.g., sedation, nuclear agent)', value: 'medication_prep_or_timing_error' },
      { label: 'Other', value: 'protocol_other' },
    ],
    value: 'protocol_procedure_error',
  },
  {
    label: 'Image Quality Error',
    subcategories: [
      { label: 'Motion artifact', value: 'motion_artifact' },
      { label: 'Poor contrast or brightness', value: 'poor_contrast_or_brightness' },
      { label: 'Image noise', value: 'image_noise' },
      { label: 'Spatial Resolution', value: 'spatial_resolution' },
      { label: 'Metal or implant artifact', value: 'metal_or_implant_artifact' },
      { label: 'Other artifacts', value: 'other_artifacts' },
      { label: 'Field of view', value: 'field_of_view' },
      { label: 'Fat suppression', value: 'fat_suppression' },
      { label: 'Imaging plane or projection', value: 'imaging_plane_or_projection' },
      { label: 'Patient positioning', value: 'patient_positioning' },
      { label: 'Other', value: 'image_other' },
    ],
    value: 'image_quality_error',
  },
  {
    label: 'Policy / Safety / Compliance Error',
    subcategories: [
      { label: 'Timeout not performed', value: 'timeout_not_performed' },
      { label: 'Incorrect patient identification', value: 'incorrect_patient_identification' },
      { label: 'Wrong site/side/level not confirmed', value: 'wrong_site_side_level_not_confirmed' },
      { label: 'Incomplete MR safety screening', value: 'incomplete_mr_safety_screening' },
      { label: 'Incorrect agent administered', value: 'incorrect_agent_administered' },
      { label: 'Pregnancy screening not performed', value: 'pregnancy_screening_not_performed' },
      { label: 'Pediatric or radiation safety protocol not followed', value: 'pediatric_or_radiation_safety_protocol_not_followed' },
      { label: 'Sedation monitoring not performed', value: 'sedation_monitoring_not_performed' },
      { label: 'Consent not obtained appropriately', value: 'consent_not_obtained_appropriately' },
      { label: 'Contrast extravasation policy not followed', value: 'contrast_extravasation_policy_not_followed' },
      { label: 'Contrast allergy prep policy not followed', value: 'contrast_allergy_prep_policy_not_followed' },
      { label: 'Other', value: 'policy_other' },
    ],
    value: 'policy_safety_compliance_error',
  },
  {
    label: 'Documentation Error',
    subcategories: [
      { label: 'Wrong patient linked to study', value: 'wrong_patient_linked_to_study' },
      { label: 'Wrong accession number', value: 'wrong_accession_number' },
      { label: 'Series or images mislabeled', value: 'series_or_images_mislabeled' },
      { label: 'Missing or incomplete clinical history', value: 'missing_or_incomplete_clinical_history' },
      { label: 'Missing or incomplete radiologic contrast documentation', value: 'missing_or_incomplete_radiologic_contrast_documentation' },
      { label: 'Missing radiation dose information', value: 'missing_radiation_dose_information' },
      { label: 'Incomplete ultrasound worksheet', value: 'incomplete_ultrasound_worksheet' },
      { label: 'Missing pregnancy or allergy documentation', value: 'missing_pregnancy_or_allergy_documentation' },
      { label: 'Sedation documentation', value: 'sedation_documentation' },
      { label: 'Missing screening/consent forms', value: 'missing_screening_consent_forms' },
      { label: 'Exam not properly closed out', value: 'exam_not_properly_closed_out' },
      { label: 'Missing laterality description', value: 'missing_laterality_description' },
      { label: 'Incomplete information about technical problems or patient noncompliance', value: 'incomplete_information_about_technical_problems_or_patient_noncompliance' },
      { label: 'Other', value: 'documentation_other' },
    ],
    value: 'documentation_error',
  },
  {
    label: 'IT / System Error',
    subcategories: [
      { label: 'PACS transmission failure', value: 'pacs_transmission_failure' },
      { label: 'RIS/HIS integration error', value: 'ris_his_integration_error' },
      { label: 'Scanner malfunction', value: 'scanner_malfunction' },
      { label: 'System freeze or crash', value: 'system_freeze_or_crash' },
      { label: 'DICOM header mismatch', value: 'dicom_header_mismatch' },
      { label: 'Templated fields not populating correctly', value: 'templated_fields_not_populating_correctly' },
      { label: 'Exam deleted or lost during transfer', value: 'exam_deleted_or_lost_during_transfer' },
      { label: 'Other', value: 'it_other' },
    ],
    value: 'it_system_error',
  },
];

// Helper functions matching backend

export function getCategoryLabel(categoryValue) {
  const category = OBSERVATION_CATEGORIES_DATA.find((cat) => cat.value === categoryValue);
  return category?.label || categoryValue;
}

export function getSubcategoryLabel(subcategoryValue) {
  const subcategory = OBSERVATION_CATEGORIES_DATA.flatMap((category) => category.subcategories).find((sub) => sub.value === subcategoryValue);

  return subcategory?.label || subcategoryValue;
}

export function getCategoryOptions() {
  return OBSERVATION_CATEGORIES_DATA.map((cat) => ({
    label: cat.label,
    value: cat.value,
  }));
}

export function getSubcategoryOptions(categoryValue) {
  const category = OBSERVATION_CATEGORIES_DATA.find((cat) => cat.value === categoryValue);
  return (
    category?.subcategories.map((sub) => ({
      label: sub.label,
      value: sub.value,
    })) || []
  );
}

export function getSubcategoriesByCategory() {
  return OBSERVATION_CATEGORIES_DATA.reduce(
    (result, category) => ({
      ...result,
      [category.value]: category.subcategories.map((sub) => ({
        label: sub.label,
        value: sub.value,
      })),
    }),
    {}
  );
}
